/// <reference path="../Bases/GridBase.ts" />
namespace _Ext {
    import fld = TabAurous.Purchase.PurchaseLaborRow.Fields;
    @Serenity.Decorators.registerClass([Serenity.IGetEditValue, Serenity.ISetEditValue, Serenity.IReadOnly])
    @Serenity.Decorators.editor()
    @Serenity.Decorators.element("<div/>")
    export class MFGLaborGridEditor<TEntity> extends _Ext.GridBase<TEntity, any>
        implements Serenity.IGetEditValue, Serenity.ISetEditValue, Serenity.IReadOnly {

        public pendingChanges: Q.Dictionary<any> = {};
        protected get_ExtGridOptions(): ExtGridOptions { return Q.deepClone(q.DefaultEditorGridOptions); }

        protected getIdProperty() { return "__id"; }

        isChildGrid = true;

        protected nextId = 1;

        constructor(container: JQuery) {
            super(container);

            this.slickGrid.onSort.subscribe((e, args) => {
                this.sortGridFunction((args.grid as Slick.Grid), args.sortCols[0], args.sortCols[0].sortCol.field);

                //(args.grid as Slick.Grid).init();
                (args.grid as Slick.Grid).invalidateAllRows();
                (args.grid as Slick.Grid).invalidate();
                (args.grid as Slick.Grid).render();
                (args.grid as Slick.Grid).resizeCanvas();
            });

        }

        private sortGridFunction(grid: Slick.Grid, column: any, field: any) {
            grid.getData().sort(function (a, b) {
                var result = a[field] > b[field] ? 1 :
                    a[field] < b[field] ? -1 :
                        0;
                return column.sortAsc ? result : -result;
            });
        }

        protected getQuickFilters() {
            return [];
        }

        protected id(entity: TEntity) {
            return (entity as any)[this.getIdProperty()];
        }

        protected save(opt: Serenity.ServiceOptions<any>, callback: (r: Serenity.ServiceResponse) => void) {
            var request = opt.request as Serenity.SaveRequest<TEntity>;
            var row = Q.deepClone(request.Entity);

            var id = this.id(row);
            if (id == null) {
                row[this.getIdProperty()] = "`" + this.nextId++;
            }

            if (!this.validateEntity(row, id)) {
                return;
            }

            var items = this.view.getItems().slice();
            if (id == null) {
                items.push(row);
            }
            else {
                var index = Q.indexOf(items, x => this.id(x) === id);
                items[index] = Q.deepClone({} as TEntity, items[index], row);
            }

            this.value = items;
            callback({});
        }

        protected deleteEntity(id: number) {
            this.view.deleteItem(id);
            setTimeout(() => {
                this.onItemsChanged();
                this.element.trigger('change');
                this.resetRowNumber();
            });
            return true;
        }

        protected validateEntity(row: TEntity, id: number) {
            return true;
        }

        protected getNewEntity(): TEntity {
            return {} as TEntity;
        }

        protected getButtons(): Serenity.ToolButton[] {
            return [{
                title: this.getItemName(),
                cssClass: 'add-button',
                onClick: () => { this.addButtonClick() }
            }];
        }

        public getEditValue(property, target) {
            target[property.name] = this.value;
        }

        public setEditValue(source, property) {
            this.value = source[property.name];
        }

        public get value(): TEntity[] {
            var p = this.getIdProperty();

            (this.slickGrid as any).getEditController().commitCurrentEdit();

            let items = this.view.getItems();

            this.onBeforeGetValue(items);

            return items.map(x => {
                var y = Q.deepClone(x);
                var id = y[p];
                if (id && id.toString().charAt(0) == '`')
                    delete y[p];

                if (y['RowNum'])
                    delete y['RowNum'];
                return y;
            });
        }

        public set value(value: TEntity[]) {
            var id = this.getIdProperty();

            let val = value || [];

            let items = val.map(x => {
                var y = Q.deepClone(x);
                if ((y as any)[id] == null) {
                    (y as any)[id] = "`" + this.nextId++;
                }
                return y;
            });

            let r = this.onViewProcessData({ Entities: items })
            this.view.setItems(r.Entities, true);
            setTimeout(() => {
                this.onItemsChanged();
                this.element.trigger('change');
            });
            this.resetRowNumber(); // to generate serial no.
        }

        protected getGridCanLoad() {
            return false;
        }

        protected usePager() {
            return false;
        }

        protected getInitialTitle() {
            return null;
        }

        private searchText: string;

        protected createToolbarExtensions(): void {
            //super.createToolbarExtensions();
            if (this.get_ExtGridOptions().EnableQuickSearch) {
                Serenity.GridUtils.addQuickSearchInputCustom(this.toolbar.element, (field, text) => {
                    this.searchText = Select2.util.stripDiacritics(Q.trimToNull(text) || '').toLowerCase();
                    this.view.setItems(this.view.getItems(), true);
                });
            }
        }

        protected onViewFilter(row): boolean {
            if (!super.onViewFilter(row)) {
                return false;
            }

            if (this.searchText) {
                return this.matchContains(row);
            }

            return true;
        }

        private matchContains(item): boolean {
            let result = false;

            for (let prop in item) {
                result = Select2.util.stripDiacritics(String(item[prop] || '')).toLowerCase().indexOf(this.searchText) >= 0;

                if (result == true) {
                    return result;
                }
            }

            return result;
        }

        // **** to Call shortcut key in Main Window
        protected createToolbar(buttons: Serenity.ToolButton[]): void {
            var toolbarDiv = $('<div class="grid-toolbar"></div>').appendTo(this.element);
            this.toolbar = new Serenity.Toolbar(toolbarDiv, { buttons: buttons, hotkeyContext: document.getElementsByTagName('body')[0] });
        }

        protected enableFiltering(): boolean { return false; }

        protected onViewSubmit() { return false; }

        get_readOnly(): boolean {
            return this.isReadOnly;
        }
        set_readOnly(value: boolean): void {
            this.isReadOnly = value;
            if (value == true) {
                this.element.find('.add-button').addClass('disabled');
                let opt = this.slickGrid.getOptions();
                opt.editable = false;

                this.slickGrid.setOptions(opt);
            } else {
                this.element.find('.add-button').removeClass('disabled');
            }

        }

        protected getSlickOptions() {
            let opt = super.getSlickOptions();
            opt.forceFitColumns = false;
            //opt.autoHeight = true; // If you need to show footer, you have to do opt.autoHeight = false
            return opt;
        }

        parentDialog: MFGTransItemDialog<any, any>;

        //custom events
        onItemsChanged() {

        }
        onBeforeGetValue(items: TEntity[]) {

        }

        public inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row) as any;
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            var effective = this.getEffectiveValue(item, field);
       
            //// *** Format Number ***
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.LabourRate || field === fld.LabourAmount) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.LabourRate && value > 0) {

                if (item.MarkUp > 0) {
                    item.LabourAmount = item.CalcOnId == 3 ? item.Pieces * (value + (value * (item.MarkUp / 100))) : item.Weight * (value + (value * (item.MarkUp / 100)));
                }
                else {
                    item.LabourAmount = item.CalcOnId == 3 ? item.Pieces * value : item.Weight * value;
                }
                item[field] = value;
            }

            if (field === fld.MarkUp && value > 0) {
                item.LabourAmount = item.CalcOnId == 3 ? item.Pieces * (item.LabourRate + (item.LabourRate * (value / 100))) : item.Weight * (item.LabourRate + (item.LabourRate * (value / 100)));
                item[field] = value;
            }

            if (field == fld.CalcOnId && value > 0) {
                item[field] = value;
            }

            //item.CCLabourAmount = item.LabourAmount * this.ExchangeRate;
            this.view.updateItem(id, item);
            this.view.refresh();
            (this.parentDialog as any).CalculateTotals();

            //if (input.hasClass('numeric'))
            //    value = Q.formatNumber(value, '0.00');

            //if (input.hasClass('integer'))
            //    value = Q.formatNumber(value, '0');

            //input.val(value).addClass('dirty');
        }
        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        InlineLookup(RowIndex: string, Items: any[]) {

            var select = $("#LCalcId" + RowIndex);

            if (!select.hasClass("select2-offscreen")) {

                let opt: Serenity.LookupEditorOptions = {
                    lookupKey: 'OMS.LaborCalcOn'
                };
                var Editor = new TabAurous.InlineLookupEditor($("#LCalcId" + RowIndex), opt);
                if (this.isReadOnly == true) {
                    q.showAndDisableField(Editor);
                }
                Editor.cascadeField = "ProcessId";
                Editor.cascadeValue = Items[RowIndex].ProcessId;
                Editor.value = Q.toId(Items[RowIndex].CalcOnId);
                Editor.changeSelect2(e => {
                    this.ReCalculate(Items[RowIndex], Q.parseInteger(Editor.value))
                });
            }
            else {
                if (this.isReadOnly == false) {
                    select.closest('.slick-cell').find('.select2-container-disabled').removeClass('select2-container-disabled');
                    select.removeClass('readonly');
                }
            }
        }

        ReCalculate(item: any, value: number) {

            let parent = (this.parentDialog as any);

            switch (value) {
                case 62:
                    item.Weight = parent.form.NetWeight.value;
                    item.CalcOnId = value;
                    break;
                case 63:
                    item.Weight = parent.form.Weight.value;
                    item.CalcOnId = value;
                    break;
                case 64:
                case 65:
                    let Bom = [];
                    Bom = parent.form.BOMDetails.getItems()
                    let RMWeight = Q.tryFirst(Bom, x => x.ProductTypeId == item.ProductTypeId
                        && x.CategoryId == item.CategoryId
                        && x.SubCategoryId == item.SubCategoryId
                        && x.QualityId == item.QualityId && x.ShapeId == item.ShapeId).Weight || 0;
                    if (!isNaN(RMWeight) || RMWeight > 0) {
                        item.Weight = RMWeight;
                        item.CalcOnId = value;
                    }

                    break;
                case 61:
                    let RMPcs = Q.tryFirst(Bom, x => x.ProductTypeId == item.ProductTypeId
                        && x.CategoryId == item.CategoryId
                        && x.SubCategoryId == item.SubCategoryId
                        && x.QualityId == item.QualityId && x.ShapeId == item.ShapeId).Pieces;
                    if (!isNaN(RMPcs)) {
                        item.Pieces = RMPcs;
                        item.CalcOnId = value;
                    }
                    break;
            }
            if (item.MarkUp > 0) {
                item.LabourAmount = item.CalcOnId == 61 ? item.Pieces * (item.LabourRate + (item.LabourRate * (item.MarkUp / 100))) : item.Weight * (item.LabourRate + (item.LabourRate * (item.MarkUp / 100)));
            }
            else {
                item.LabourAmount = item.CalcOnId == 61 ? item.Pieces * item.LabourRate : item.Weight * item.LabourRate;
            }
            var id = this.id(item);
            this.view.refresh();
            this.view.updateItem(id, item);
            (this.parentDialog as any).CalculateTotals();
        }


        public ItemAtbId: number;
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;
        public TransDate: Date;
         
    }
}